import {actions, ActionType} from './action';
import {PageInfo} from '../../common/util/PageRouter';
import {
  createReducer,
  createBasicReducerHandlers,
  ReducerActionHelper,
} from '../../common/util/redux';
import {
  IUser,
  IApiParamsAuthResult,
  ILastLoginAuth,
  IAuthModal,
  IIdVerificationModalType,
  ITermsItem,
} from '../type';

export interface IStateAuth {
  user?: IUser;
  isFetchUserFinished: boolean;
  apiParamsAuthResult?: IApiParamsAuthResult;
  apiError?: {type: string; msg?: string};
  isFromEvictedPopup: boolean;
  lastLoginAuth?: ILastLoginAuth;
  isClosedContinueLogin?: boolean;
  isFirstVisitLoginPage: boolean;
  isCherryPicking: boolean;
  cdnDomain?: string;
  isRoutingFirstVisitLoginPage: boolean;
  authModal: IAuthModal;
  idVerificationModal?: {
    type: IIdVerificationModalType;
    pageInfoAfterClose?: PageInfo;
  };
  termsList: ITermsItem[];
  termsParentList: ITermsItem[];
  birthday?: string;
}

const INITIAL_STATE: IStateAuth = {
  user: undefined,
  isFetchUserFinished: false,
  isFromEvictedPopup: false,
  isFirstVisitLoginPage: true,
  isRoutingFirstVisitLoginPage: false,
  isCherryPicking: true,
  authModal: {show: false},
  termsList: [],
  termsParentList: [],
};

export default createReducer<IStateAuth, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
      removeValuesActionType: ActionType.RemoveValues,
    }),
    [ActionType.ClearAuthParams]: state => {
      state.apiParamsAuthResult = undefined;
      state.authModal = INITIAL_STATE.authModal;
    },
  }
);
